import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { bbAxios, derenderText, formatDate } from "../../util";
import { BlogArticle } from "./BlogArticle";
import { Icon } from "react-fa";
import { Helmet } from "react-helmet";
import imgSample from "../../../img/sample/sample_farm_2.png";
import imgIcon from "../../../img/logo/bb_logo_192x192.png";
import i18n from "i18next";
import "./BlogOverview.scss";
import { Card } from "react-bootstrap";
import { config } from "../../Config";
import { AboutHeader } from "../Page";

const ListMore = ({ posts }) =>
  !posts?.length ? null : (
    <div>
      <div className="row mt-3 justify-content-center">
        <div className="col-12 col-md-11">
          <h2 className="more_news_title">{i18n.t("More news")}</h2>
        </div>
      </div>
      {posts.map((post) => (
        <div className="row pb-1 justify-content-center" key={post.id}>
          <div className="col-3 col-md-2">
            <span className="date">{formatDate(post.publish_date)}</span>
          </div>
          <div className="col-9 col-md-8">
            <Link to={`/blog/${post.id}`}>{post.article_title}</Link>
          </div>
        </div>
      ))}
    </div>
  );

const BlogPostShort = ({ post }) =>
  !post ? null : (
    <div className="col-12 col-md-6">
      <Card>
        <Card.Header className="position-relative p-0">
          <div className="blog-avatar d-flex">
            <img alt={i18n.t("Author")} className="avatar" src={post.picture_small || imgIcon} />
            <h5 className="blogger_title text-white align-self-center ml-3">
              {post.author_title || i18n.t("CropFields")}
            </h5>
          </div>
          <Card.Img
            className="blog_hero_image d-none d-sm-block"
            src={post.picture_large || imgSample}
            alt="Title"
            variant="top"
          />
        </Card.Header>
        <Card.Body>
          <Card.Title>{post.article_title}</Card.Title>
          <Card.Text className="date">{formatDate(post.publish_date)}</Card.Text>
          <div dangerouslySetInnerHTML={{ __html: post.summary }} />
          <Link className="inline-link" to={`/blog/${post.id}`}>
            {i18n.t("Read more")}
          </Link>
        </Card.Body>
      </Card>
    </div>
  );

interface BlogState {
  state?: any;
  result?: any;
  posts?: any[];
}
const cache = { result: undefined };
export const BlogOverview = ({ match }) => {
  const [blogs, setBlogs] = useState<BlogState>({});
  useEffect(() => {
    let unmounted = false;
    if (blogs.state || unmounted) return;
    setBlogs({ state: "fetching" });
    if (cache.result) {
      setBlogs(cache.result);
      return;
    }
    bbAxios
      .get(`${config.FRONT_URL}/cms_api/articles/`, {
        params: {
          product: "boer_en_bunder",
          language: config.language,
        },
      })
      .then(({ data }) => setBlogs((cache.result = { posts: data, state: "fetched" })))
      .catch((err) => setBlogs((cache.result = { posts: [], state: "error" })));
    return () => {
      unmounted = true;
    };
  }, [blogs.state]);

  const id = parseInt(match.params.id, 10),
    { posts = [], state } = blogs,
    post = posts.find((p) => p.id === id);
  const [p1, p2, ...rest] = posts;
  let content;
  if (state !== "fetched") {
    content = (
      <h2 className="center">
        <Helmet>
          <title>{i18n.t("Loading blog") + "..."}</title>
        </Helmet>
        {state === "fetching" ? (
          <span>
            {i18n.t("Loading blog") + "..."} <Icon spin name="spinner" />
          </span>
        ) : (
          i18n.t("Blog unavailable")
        )}
      </h2>
    );
  } else if (post) {
    content = <BlogArticle post={post} />;
  } else {
    content = (
      <div className="row">
        <BlogPostShort post={p1} />
        <BlogPostShort post={p2} />
      </div>
    );
  }

  return (
    <section className="section_page">
      <Helmet>
        <title>{(post && derenderText(post.article_title)) || i18n.t("CropFields blog")}</title>
      </Helmet>
      <div className={`container_page scrollable container_blog_${post ? "article" : "overview"}`}>
        <div className="row">
          <div className="col-12">
            <h1 className="news_title">
              <AboutHeader active={post ? "" : "/blog/"} />
              <Link
                type="button"
                className={post ? "btn-back" : "btn-close"}
                style={{ float: "right" }}
                to={post ? "/blog" : "/"}
              />
            </h1>
          </div>
        </div>
        {content}
        <ListMore posts={rest} />
      </div>
    </section>
  );
};
